import { render, staticRenderFns } from "./addCurriculum.vue?vue&type=template&id=2edeee03&scoped=true"
import script from "./addCurriculum.vue?vue&type=script&lang=js"
export * from "./addCurriculum.vue?vue&type=script&lang=js"
import style0 from "./addCurriculum.vue?vue&type=style&index=0&id=2edeee03&prod&lang=less&scoped=true"
import style1 from "./addCurriculum.vue?vue&type=style&index=1&id=2edeee03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edeee03",
  null
  
)

export default component.exports